app.controller("ManageRolesController", ["$scope", "$uibModalInstance", "params", "Access", "Users", "Position",
    function ($scope, $uibModalInstance, params, Access, Users, Position) {
        console.log(params)
        $scope.role = [];
        $scope.positionName = params.position ? params.position.name : null;
        var positionId = params.position ? params.position._id : null;

        $scope.chosenRoles = {};
        function loadRoles() {
            Access.fetchRoleList(params.type).then(function (data) {
                $scope.roles = data;
                if(params.type === 'USER') {
                    Users.fetchOne(params.user).then(function (data) {
                        $scope.user = data;
                        $scope.user.roles.forEach(function (role) {
                            $scope.chosenRoles[role] = true;
                        });
                    });
                } else if(params.type === 'DOCFLOW') {
                    Position.fetchOne(positionId).then(function (data) {
                        $scope.user = data;
                        $scope.user.roles.forEach(function (role) {
                            $scope.chosenRoles[role] = true;
                        });
                    });
                }
            });
        }

        loadRoles();

        $scope.change = function (role, val) {
            if(val) $scope.revoke(role._id);
            if(!val) $scope.assign(role._id);
        };

        $scope.assign = function (roleId) {
            if(params.type === 'USER') {
                Access.AssignRole({userId: params.user, roleId: roleId}).then(function (role) {
                });
            } else if(params.type === 'DOCFLOW') {
                Position.AssignRole({positionId: positionId, roleId: roleId}).then(function (role) {
                });
            }
        };

        $scope.revoke = function (roleId) {
            if(params.type === 'USER') {
                Access.RevokeRole({userId: params.user, roleId: roleId}).then(function (role) {
                });
            } else if(params.type === 'DOCFLOW') {
                Position.RevokeRole({positionId: positionId, roleId: roleId}).then(function (role) {
                });
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
